import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalFooter,
  ModalHeader,
  Text,
  Button,
  Flex,
  Spinner,
} from '@televet/kibble-ui';
import React from 'react';

interface PairingPinModalProps {
  pin?: string;
  isGeneratingPin?: boolean;
  isOpen: boolean;
  onClose: () => void;
}

const PairingPinModal = ({ pin, isGeneratingPin, isOpen, onClose }: PairingPinModalProps): JSX.Element => {
  return (
    <Modal size="sm" isOpen={isOpen} onClose={onClose}>
      <ModalHeader size="lg">Pairing PIN</ModalHeader>
      <ModalCloseButton />
      <ModalBody py={6}>
        {isGeneratingPin ? (
          <Flex direction="column" alignItems="center" gap={4}>
            <Spinner size="xl" />
            <Text>Retrieving PIN...</Text>
          </Flex>
        ) : (
          <Flex gap={4} alignItems="center" direction="column">
            <Text size="2xl" fontWeight="semibold">
              {pin}
            </Text>
          </Flex>
        )}
      </ModalBody>
      <ModalFooter justifyContent="center">
        <Button variant="tertiary" width="fit-content" onClick={onClose}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default PairingPinModal;
